/* Keep the PDP and cart suggestions in sync after native cart mutations.
   Selection, prices and translations remain server-rendered Liquid. */
(() => {
  if (window.patCrossSellBound) return;
  window.patCrossSellBound = true;
  let timer;
  let revision = 0;
  let controller;
  const selector = '[data-pa-cross-sell-kind]';

  function removeCartItems(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    const ids = new Set();
    for (const item of cart.items) {
      ids.add(String(item.product_id));
      for (const component of item.item_components || []) ids.add(String(component.product_id));
    }
    for (const section of document.querySelectorAll(selector)) {
      for (const card of section.querySelectorAll('[data-pa-product-id]')) {
        if (ids.has(card.dataset.paProductId)) card.remove();
      }
      const slider = section.querySelector('.swiper');
      if (slider && slider.swiper) slider.swiper.update();
      if (!section.querySelector('[data-pa-product-id]')) section.querySelector('.section-heading')?.remove();
    }
  }

  async function refresh(currentRevision) {
    controller?.abort();
    controller = new AbortController();
    const signal = controller.signal;
    // A product page has one PDP section; the cart has one additions section.
    // Bound work even if a theme editor accidentally duplicates the sections.
    const sections = [...document.querySelectorAll(selector)].slice(0, 2);
    await Promise.all(sections.map(async (section) => {
      try {
        const url = new URL(section.dataset.paCrossSellUrl, location.origin);
        if (url.origin !== location.origin) return;
        const response = await fetch(url.href, { credentials: 'same-origin', signal, cache: 'no-store' });
        if (!response.ok) return;
        const markup = await response.text();
        if (currentRevision !== revision || !section.isConnected) return;
        const parsed = new DOMParser().parseFromString(markup, 'text/html');
        const replacement = parsed.querySelector(`[data-pa-cross-sell-kind="${section.dataset.paCrossSellKind}"]`);
        if (!replacement) return;
        const slider = section.querySelector('.swiper');
        if (slider && slider.swiper) slider.swiper.destroy(true, true);
        section.innerHTML = replacement.innerHTML;
        section.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
      } catch (error) {
        // Existing server-rendered recommendations remain usable on failure.
        // No retry loop, no changes to the basket and no customer data sent.
      }
    }));
  }

  document.addEventListener('cart:change', (event) => {
    removeCartItems(event.detail?.cart);
    revision += 1;
    const currentRevision = revision;
    controller?.abort();
    clearTimeout(timer);
    timer = setTimeout(() => refresh(currentRevision), 220);
  });
})();
